// What a section of the side pane has to show, decided by the page from the batch call and shared by the Licenses
// and the Maintenance sections (buildAddonsPanel, buildMaintenancePanel).
//   ready:       the data is known: the section shows it
//   failed:      the batch failed and there is nothing earlier to show: the section says it could not be loaded
//   unavailable: the batch succeeded but did not carry the data (older rest-api, product not returned): no data
//   loading:     the batch has not arrived yet
export const PANEL_STATUS = Object.freeze({
	LOADING: 'loading',
	FAILED: 'failed',
	UNAVAILABLE: 'unavailable',
	READY: 'ready',
});
